import { getAppConfig } from '../../app.config';

/**
 * Returns the location of the server, e.g. "http://localhost:3000"
 */
export function getServerLocation(): string {
  const { apiHost } = getAppConfig();
  return `${apiHost}`;
}
